import React from 'react';
import { useEffect } from 'react';
import '../styles/AboutUs.css';
import Testimonials from '../common/Testimonials.jsx';
import OurStory from '../common/OurStory.jsx';
import OurValues from '../common/OurValues.jsx';

const AboutUs = () => {
  useEffect(() => {
    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bt-visible');
        }
      });
    }, { threshold: 0.1 });
    
    // Observe all elements with animation classes
    document.querySelectorAll('.bt-fade-in').forEach(el => observer.observe(el));
    document.querySelectorAll('.bt-slide-up').forEach(el => observer.observe(el));
    
    return () => observer.disconnect();
  }, []);
  
  // Founder info
  const founder = {
    name: "Vishvanath",
    position: "Founder & CEO",
    bio: "Vishvanath, the visionary Founder and CEO of Beaver Tours, leads the company with a passion for redefining travel experiences in India and beyond. With a keen eye for innovation and a deep respect for cultural and environmental sustainability, he has built Beaver Tours as a brand that values authenticity, trust, and transformative journeys. Under his leadership, Beaver Tours is not just a travel company—it is a movement toward purpose-driven exploration. Vishvanath believes that travel should empower both the traveler and the local communities they visit. His mission is to create seamless, safe, and personalized tours that blend modern convenience with soulful discovery.",
    image: "assets/images/founder.jpg"
  };
  
  
  
  return (
    <div className="bt-about-container">
      {/* Banner Section */}
      <section className="bt-banner-section">
        <div className="bt-banner-overlay">
          <div className="bt-banner-content">
            <h1 className="bt-banner-title">Our Journey</h1>
            <p className="bt-banner-subtitle">Exploring cities on two wheels with heart and purpose</p>
          </div>
        </div>
      </section>
      
<OurStory/>
      {/* Mission Section */}
      <section className="bt-mission-section">
        <div className="bt-wrapper">
          <div className="bt-section-header bt-fade-in">
            <h2>Our Mission & Vision</h2>
            <div className="bt-section-divider"></div>
          </div>
          
          <div className="bt-mission-content bt-slide-up">
            <div className="bt-mission-statement">
              <p>At Beaver Tours, we believe the best way to experience a city is on two wheels. Our mission is to provide eco-friendly, accessible, and memorable biking experiences while promoting sustainable tourism and supporting local communities.We envision a world where every city is explored sustainably, with cycling at the heart of urban adventures. Beaver Tours aims to expand our eco-friendly tours globally, fostering community connections and preserving local cultures for future generations.</p>
            </div>
          </div>
        </div>
      </section>

      <OurValues/>
      
      {/* Founder Section */}
      <section className="bt-founder-section">
        <div className="bt-wrapper">
          <div className="bt-section-header bt-fade-in">
            <h2>Meet Our Founder</h2>
            <div className="bt-section-divider"></div>
          </div>
          
          <div className="bt-founder-profile bt-slide-up">
            <div className="bt-founder-image">
              <img src={founder.image} alt={founder.name} />
            </div>
            <div className="bt-founder-info">
              <h3 className="bt-founder-name">{founder.name}</h3>
              <p className="bt-founder-title">{founder.position}</p>
              <p className="bt-founder-bio">{founder.bio}</p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
                <div className="cta-container">
                    <h2 className="cta-title">Ready for Your Next Adventure?</h2>
                    <p className="cta-text">
                        Book your bike today and explore the city at your own pace.
                    </p>
                    <div className="cta-buttons">
                        <a href="/book" className="cta-button primary">Book Now</a>
                        <a href="/contact" className="cta-button secondary">Contact Us</a>
                    </div>
                </div>
            </section>
     <Testimonials/>
      
      
    </div>
  );
};

export default AboutUs;